import {Component, EventEmitter, OnInit, Output, Input, Renderer2} from '@angular/core';

@Component({
  selector: 'app-request-sent',
  templateUrl: './request-sent.component.html',
  styleUrls: ['./request-sent.component.scss']
})
export class RequestSentComponent implements OnInit {
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Input() nameToDisplay: string = 'A RE/MAX agent';
  @Input() isShareForm: boolean = false;
  constructor(private _renderer: Renderer2) { }

  ngOnInit() {
    setTimeout(() => {
      this._renderer.addClass(document.querySelector('html'), 'no-scroll');
    });
  }

  close() {
    this._renderer.removeClass(document.querySelector('html'), 'no-scroll');
    this.onClose.emit();
  }
}
